import { BaseModel } from 'paliari-js-utils'

const attributes = {
  codigo: codigo => codigo || String(Date.now()),
  descricao: '',
  valor: 0,
}

class DocCalculoGrauInfracao extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default DocCalculoGrauInfracao
